// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"5c08b77b","194":"7ff7f40f","375":"3bf1ccda","887":"82e77364","900":"0955836e"}[chunkId] + ".chunk.css";
};